import { getHTMLElementFromRoot } from "../utility/helper";
import logger from "./logger";

export async function openContextualDrawer(): Promise<void> {
  try {
    await customElements.whenDefined("phn-nd-contextual-drawer");
    const contextualDrawer = getHTMLElementFromRoot(
      "phn-nd-contextual-drawer",
    ) as any;
    await contextualDrawer.openDrawer();
  } catch (error) {
    logger.error("open-contextual-drawer", error as Error);
  }
}

export async function closeContextualDrawer(): Promise<void> {
  try {
    await customElements.whenDefined("phn-nd-contextual-drawer");
    const contextualDrawer = getHTMLElementFromRoot(
      "phn-nd-contextual-drawer",
    ) as any;
    await contextualDrawer.closeDrawer();
  } catch (error) {
    logger.error("close-contextual-drawer", error as Error);
  }
}

export async function openNavigationDrawer(
  initialRoutingKeys?: string,
): Promise<void> {
  try {
    await customElements.whenDefined("phn-nd-navigation-drawer-initiater");
    const navigationDrawer = getHTMLElementFromRoot(
      "phn-nd-navigation-drawer-initiater",
    ) as any;
    await navigationDrawer.openDrawer(initialRoutingKeys);
  } catch (error) {
    logger.error("open-navigation-drawer", error as Error);
  }
}

export async function closeNavigationDrawer(): Promise<void> {
  try {
    await customElements.whenDefined("phn-nd-navigation-drawer-initiater");
    const navigationDrawer = getHTMLElementFromRoot(
      "phn-nd-navigation-drawer-initiater",
    ) as any;
    await navigationDrawer.closeDrawer();
  } catch (error) {
    logger.error("close-navigation-drawer", error as Error);
  }
}
